import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString, { ParseOptions } from 'query-string';

export const useSearch = (parseOptions: ParseOptions = {}) => {
  const { search } = useLocation();
  const optionsString = JSON.stringify(parseOptions);

  return useMemo(() => {
    const options = JSON.parse(optionsString);

    const parsedResult = queryString.parse(search, {
      parseBooleans: true,
      parseNumbers: true,
      ...options,
    });

    /* TODO временное решение в связи с добавлением множественного выбора,
    значения нужны ввиде строки '134,456', а не массива.
    необходимо в будущем сделать как в контроле, через encodeURL или иной способ
    */
    for (const property in parsedResult) {
      if (Array.isArray(parsedResult[property])) {
        const stringify = queryString.stringify(parsedResult, {
          arrayFormat: 'comma',
        });

        return queryString.parse(stringify, {
          parseBooleans: true,
          parseNumbers: true,
          ...options,
        });
      }
    }

    return parsedResult;
  }, [search, optionsString]);
};
